export enum EmailStatus {
  SUCCESS = "SUCCESS",
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  BOUNCED = "BOUNCED",
  // A bounce SES did NOT classify as Permanent — Transient (mailbox full,
  // greylisting, a downstream deferral) or Undetermined. Not terminal in the
  // parser's ladder: a later delivery/open/click overwrites it, so a row only
  // still carries this when nothing better ever followed.
  SOFT_BOUNCED = "SOFT_BOUNCED",
  COMPLAINED = "COMPLAINED",
  REJECTED = "REJECTED",
  FAILED = "FAILED",
  DELAYED = "DELAYED",
  PENDING = "PENDING",
  // Terminal "not sent" state — written when a send is skipped (row
  // carries skipReason).
  SKIPPED = "SKIPPED",
  // TODO
  OPEN = "OPEN",
  CLICK = "CLICK",
}
